import { useQuery } from "@tanstack/react-query";
import type { PartnerGoal } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/goals/:id — single goal spec.
export function useGoal(id: string | undefined) {
  return useQuery<PartnerGoal, ApiClientError>({
    queryKey: queryKeys.goals.detail(id ?? ""),
    queryFn: () => apiFetch<PartnerGoal>(`/admin/goals/${id}`),
    enabled: !!id,
  });
}
